"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataGridNewTextCellRenderer = void 0;
const DataGridNew_1 = require("../..");
function dataGridNewTextCellRenderer({ cellData, columnWidth, disabled, inactive, tooltipMaxWidth }) {
    return (0, DataGridNew_1.dataGridNewTrimmedTextRenderer)({
        cellData,
        columnWidth,
        disabled,
        inactive,
        tooltipMaxWidth
    });
}
exports.dataGridNewTextCellRenderer = dataGridNewTextCellRenderer;
//# sourceMappingURL=dataGridNewTextCellRenderer.js.map